import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectViewMode = createSelector(
  [(store: RootState) => store.documentsSignerList.viewMode],
  (data) => data
);
